const baseRoute = 'advanced-search/:moduleBridgeHex/';
export default {
  user_module_advancedSearch_home: {
    path: `${baseRoute}home/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
};
